import React, { PropsWithChildren } from "react";
import Footer from "./footer";
import Header from "./header";
import "../styles/font.css";
import "../styles/brand.css";
import { onScrollGlobal } from "utils/helpers/project";

const Layout: React.FC<PropsWithChildren<{ simple?: boolean }>> = ({
  children,
  simple,
}) => {
  return (
    <>
      {simple ? (
        <main data-scroll="">
          {children}
          <Footer />
        </main>
      ) : (
        <main>
          <Header />
          <view id="mainScroll" data-scroll="" onScroll={onScrollGlobal}>
            {children}
          </view>
        </main>
      )}
    </>
  );
};

export default Layout;
